// The end states that a Clover transaction can be in as displayed to the user.
// This is essentially a simplified version of CloverPaymentAndRefundResult and CloverPaymentAndRefundVoidReason that
// includes CANCELLED. If we implement additional functionality we may want to extend this.
const CloverTransactionEndState = Object.freeze({
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR',
    REFUNDED: 'REFUNDED',
    REFUND_FAILED: 'REFUND_FAILED',
    SUCCESS: 'SUCCESS',
    VOID: 'VOID',
    VOID_FAILED: 'VOID FAILED',
});

module.exports = CloverTransactionEndState;
